var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"prism-player",attrs:{"id":"player-con"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }